export default __webpack_public_path__ + "static/media/ic-temp-cold.91be15ea.svg";